/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * String matcher. Exactly one of `exact`, `prefix` or `regex` must be set.
 */
export type StringMatch = {
  /**
   * Matches when the input equals this value.
   */
  exact?: string | undefined;
  /**
   * Matches when the input starts with this value.
   */
  prefix?: string | undefined;
  /**
   * Matches when the input satisfies this RE2 regular expression. Invalid
   *
   * @remarks
   * patterns are rejected when the policy is created.
   */
  regex?: string | undefined;
  /**
   * Compare case-insensitively. May accompany any match mode.
   */
  ignoreCase?: boolean | undefined;
};

/** @internal */
export const StringMatch$inboundSchema: z.ZodType<
  StringMatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  exact: z.string().optional(),
  prefix: z.string().optional(),
  regex: z.string().optional(),
  ignoreCase: z.boolean().optional(),
});
/** @internal */
export type StringMatch$Outbound = {
  exact?: string | undefined;
  prefix?: string | undefined;
  regex?: string | undefined;
  ignoreCase?: boolean | undefined;
};

/** @internal */
export const StringMatch$outboundSchema: z.ZodType<
  StringMatch$Outbound,
  z.ZodTypeDef,
  StringMatch
> = z.object({
  exact: z.string().optional(),
  prefix: z.string().optional(),
  regex: z.string().optional(),
  ignoreCase: z.boolean().optional(),
});

export function stringMatchToJSON(stringMatch: StringMatch): string {
  return JSON.stringify(StringMatch$outboundSchema.parse(stringMatch));
}
export function stringMatchFromJSON(
  jsonString: string,
): SafeParseResult<StringMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => StringMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'StringMatch' from JSON`,
  );
}
